import { DocumentListCard } from '@yes.technology/react-toolkit'
import DataTables from '../../DataTables/DataTables'
import { ChartTemplate } from '../Cockpit.types'
import { CenteredTitle, Container } from './styles'

type DataTablesChartProps = {
  props?: ChartTemplate['props']
  title: string
}

const DataTablesChart = ({ props, title }: DataTablesChartProps) => {
  if (!props) return null

  return (
    <Container>
      <CenteredTitle>{title}</CenteredTitle>
      <DocumentListCard style={{ padding: 0 }}>
        <DataTables
          props={{
            ...props
          }}
        />
      </DocumentListCard>
    </Container>
  )
}

export default DataTablesChart
